import React from 'react';
import styles from 'styles/modules/Post.module.scss';

const PostHead = ({ children }) => {
    return (
        <div className={['mb-xl', styles.postHead].join(' ')}>{children}</div>
    );
};

export default PostHead;
